import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {Button} from "reactstrap";
import Access from "constants/Access";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'Firearm Manufacture',
		url: '/products/manufactureds',
		icon: 'wrench',
	}
];

export default class Manufactured extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {


		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/products/manufactureds/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button onClick={() => {
					}/* FIXME */} size="sm" color="primary">
						<i className="fa fa-wrench"/>&nbsp;&nbsp;Manufacture Firearm
					</Button>
					<Button onClick={() => {
					}/* FIXME */} size="sm" color="primary">
						<i className="fa fa-wrench"/>&nbsp;&nbsp;Federal Excise Tax Form
					</Button>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Products" value="details"/>
					{ this.props.userAccess <Access.Supervisor&&<Tab label="Change Log" value="logs"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Manufactured
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'logs' && this.props.userAccess <Access.Supervisor&&
				<Collections.LogsAcquisitions
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		)
	}
};